import { render, staticRenderFns } from "./lazyload-demo.vue?vue&type=template&id=4dd173b2&scoped=true"
import script from "./lazyload-demo.vue?vue&type=script&lang=js"
export * from "./lazyload-demo.vue?vue&type=script&lang=js"
import style0 from "./lazyload-demo.vue?vue&type=style&index=0&id=4dd173b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd173b2",
  null
  
)

export default component.exports